import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { API_ciudadanos, API_recursos } from "../../config/apiConfig";
import { FaLocationDot, FaPhone, FaClock } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import Cita from "../../components/ciudadano/CitaSS";
import Recursos from "../../components/carrusel/UserRecursosSociales";
import "./css/Social.css";
import { useAuth } from "../../context/AuthContext";

const Social = () => {
  // Estad global y del usuario logueado
  const { user } = useSelector((state) => state.auth);
  const [datosUsuario, setDatosUsuario] = useState(null);
  const { token } = useAuth();

  const navigate = useNavigate();
  const [mostrarFormularioCita, setMostrarFormularioCita] = useState(false);
  const [categoria, setCategoria] = useState("destacadas");
  const [recursos, setRecursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.email) return;
    const fetchCiudadano = async () => {
      const res = await fetch(API_ciudadanos, {
        headers: {
          "x-auth-token": token,
        },
      });
      const data = await res.json();
      const normalize = (s) =>
        s
          ?.normalize("NFD")
          .replace(/[\\u0300-\\u036f]/g, "")
          .toLowerCase();
      const encontrado = data.find(
        (c) =>
          normalize(c.email) === normalize(user.email) ||
          (normalize(c.name) === normalize(user.name) && normalize(c.lastName) === normalize(user.lastName))
      );
      setDatosUsuario(encontrado);
    };
    fetchCiudadano();
  }, [user]);

  useEffect(() => {
    const obtenerRecursos = async () => {
      try {
        const response = await fetch(`${API_recursos}`, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await response.json();
        setRecursos(data);
      } catch (error) {
        console.error("Error al obtener recursos:", error);
        setRecursos([]);
      } finally {
        setLoading(false);
      }
    };

    obtenerRecursos();
  }, [token]);

  return (
    <>
      <Navbar />

      <main className="main-user social between">
        <section className="informacion-social column gap-50">
          {/* Recursos sociales */}
          <div>
            <h1 className="titulo-user mayusculas mb-10 align-center">
              recursos sociales:
              <select
                aria-label="Filtrados por"
                className="desplegable-empleo mayusculas ml-5"
                value={categoria}
                onChange={(e) => setCategoria(e.target.value)}
              >
                <option value="destacadas">destacados</option>
                <option value="Subvenciones">Subvenciones Temporales</option>
                <option value="Prestaciones">Prestaciones</option>
                <option value="Vivienda">Vivienda</option>
                <option value="todas">TODoS</option>
              </select>
            </h1>

            {/* Carrusel */}
            <Recursos categoria={categoria} />
          </div>
        </section>

        <article className="column gap-15">
          {/* Solicitar Cita a los Servicios Sociales - Botón */}
          <button className="boton-modal boton azul" onClick={() => setMostrarFormularioCita(true)}>
            Pedir Cita con Servicios Sociales
          </button>

          {/* Solicitar Cita a los Servicios Sociales - Formulario */}
          {mostrarFormularioCita && datosUsuario && (
            <div className="modal-overlay ">
              <div className="modal-content">
                <Cita onClose={() => setMostrarFormularioCita(false)} datosUsuario={datosUsuario} servicio="Servicios Sociales" />
              </div>
            </div>
          )}

          {/* Botón Más recursos */}
          <button className="boton-modal boton azul mb-20" onClick={() => navigate("/recursos", { state: { categoria: "social" } })}>
            Ver más recursos
          </button>

          {/* Información Servicios Sociales */}
          <div className="column gap-20 mt-20">
            <h3 className="titulo-user align-center mayusculas mb-10">SERVICIOS SOCIALES de isla cristina</h3>

            {/* Presentación Servicios Sociales */}
            <div className="column gap-10">
              <p className="align-center gap-5 ubicacion">
                <FaLocationDot />
                Av. España, 99, 21410, Isla Cristina, Huelva
              </p>
              <p className="align-center gap-5 ubicacion">
                <FaPhone />
                959 33 05 76
              </p>
              <p className="align-center gap-5 ubicacion">
                <FaClock />
                L-V de 08:00 a 15:00
              </p>
            </div>
            <p>
              <strong>¿Qué son los SS.CC.?</strong> <br></br>Son el primer nivel de referencia para la valoración de las necesidades, la
              planifiación, la intervención, el tratamiento, el seguimiento y la evaluación de la atención para los ciudadanos de Isla
              Cristina.{" "}
            </p>
          </div>
        </article>
      </main>
    </>
  );
};

export default Social;
